// Components
import * as fontFaceObserver from './components/fontFaceObserver';
import * as gmap from './components/gmap';
import * as scroll from './components/scroll';
import * as slideLink from './components/slideLink';
import * as carousel from './components/carousel';
import * as tooltip from './components/tooltip';
import * as breadcrumb from './components/breadcrumb';
import * as menuMainSub from './components/menuMainSub';
import * as macy from './components/macy';
import * as tabs from './components/tabs';
import * as years from './components/years';
import * as datepicker from './components/datepicker';
import * as select from './components/select';
import * as toTop from './components/toTop';
import * as toggle from './components/toggle';
import * as youtube from './components/youtube';
import * as gallery from './components/gallery';
import * as menuMain from './components/menuMain';
import * as header from './components/header';
import * as hint from './components/hint';
import * as profile from './components/profile';
import * as logo from './components/logo';
import * as label from './components/label';
import * as carouselImg from './components/carouselImg';
import * as tableResponsive from './components/tableResponsive';
import * as menuTabs from './components/menuTabs';
import * as objectFit from './components/objectFit';
import * as sticky from './components/sticky';
import * as waypoints from './components/waypoints';
import * as visaGuide from './components/visaGuide';

const components = [
	fontFaceObserver,
	gmap,
	scroll,
	slideLink,
	carousel,
	tooltip,
	breadcrumb,
	menuMainSub,
	macy,
	tabs,
	years,
	datepicker,
	select,
	toTop,
	toggle,
	youtube,
	gallery,
	menuMain,
	header,
	hint,
	profile,
	logo,
	label,
	carouselImg,
	tableResponsive,
	menuTabs,
	objectFit,
	sticky,
	waypoints,
	visaGuide,
];

window.App = {
	run(options) {
		this.options = options;

		components.forEach(this.initComponent);
	},

	initComponent(component) {
		return component.init();
	},
};



// WEBPACK FOOTER //
// ./src/js/app.js